<div [formGroup]="form" class="form-group">
  <div
    class="d-flex align-items-center justify-content-between mb-3"
    *ngIf="field.label"
  >
    <div>
      <label>
        {{ field.label }}{{ field.validation?.required ? '*' : '' }}
      </label>
      <app-info-icon
        [message]="field.infoIconMessage"
        *ngIf="field.infoIconMessage"
      ></app-info-icon>
    </div>
    <div
      *ngIf="field.appendFirstName"
      class="add-fist-name"
      (mousedown)="onButtonMouseDown($event)"
      (click)="insertFirstName($event)"
    >
      {{ labels.ADD_FIST_NAME }}
    </div>
  </div>
  <textarea
    #textArea
    class="form-control app-text-area"
    [formControlName]="field.name"
    (focus)="onFocus()"
    [placeholder]="field.placeholder || ''"
    (blur)="trimInputValue()"
    [maxlength]="maxLength"
  ></textarea>
  <span class="character-count">
    {{ characterCountText }}
  </span>
  <app-validation-errors
    [control]="form.get(field.name)"
    [field]="field"
  ></app-validation-errors>
</div>
